import React, { ReactNode } from 'react'
import styled, { useTheme } from 'styled-components'
import { TailSpin as Loader } from 'react-loader-spinner'
import { FullPageCenteredPageContent } from './LayoutComponents'

const LoaderStyled = styled(Loader)`
  display: flex;
  padding: 32px;
`

function Loading({ children }: { children?: ReactNode }) {
  const theme = useTheme()

  return (
    <FullPageCenteredPageContent>
      <LoaderStyled
        height={100}
        width={100}
        color={theme.palette.nswBrandAccent}
      />
      {children}
    </FullPageCenteredPageContent>
  )
}

export default Loading
